import React from "react";
import { ICellRendererParams } from "@ag-grid-community/core";

import { formatRequestNumber } from "../../../../helpers/format";
import { PickupRequestListItem } from "../../../../types";

import TwoLineGridCell from "../TwoLineGridCell";

interface Props extends ICellRendererParams {
  data: PickupRequestListItem;
}

// The column header already carries the #, so the grid drops the prefix the details page keeps.
const RequestNumberRenderer = ({ data }: Props) => (
  <TwoLineGridCell
    firstLineData={formatRequestNumber(data.requestNumber, "")}
    secondLineData={null}
  />
);

export default RequestNumberRenderer;
